import { _ } from "vue-underscore";

const tribuneA = {
  tribunePrefix: "A",
  seats: [..._.range(248, 96, -1)],
  rows: [
    {
      name: 5,
      items: [..._.range(248, 239, -1), "empty", ..._.range(239, 220, -1), 96, "empty", "empty", "empty"]
    },
    {
      name: "stairs",
      items: [...Array(9).fill("empty"), "stairs", ...Array(22).fill("empty"), "stairs"]
    },
    {
      name: 4,
      items: [..._.range(220, 211, -1), "empty", ..._.range(211, 190, -1), 97, "empty"]
    },
    {
      name: "stairs",
      items: [...Array(9).fill("empty"), "stairs", ...Array(22).fill("empty"), "stairs"]
    },
    {
      name: 3,
      items: [..._.range(190, 181, -1), "empty", ..._.range(181, 160, -1), 98, "empty"]
    },
    {
      name: "stairs",
      items: [...Array(9).fill("empty"), "stairs", ...Array(22).fill("empty"), "stairs"]
    },
    {
      name: 2,
      items: [..._.range(160, 151, -1), "empty", ..._.range(151, 130, -1), 99, "empty"]
    },
    {
      name: "stairs",
      items: [...Array(9).fill("empty"), "stairs", ...Array(22).fill("empty"), "stairs"]
    },
    {
      name: 1,
      items: [..._.range(130, 121, -1), "empty", ..._.range(121, 100, -1), 100, "empty"]
    }
  ]
};

export default tribuneA;
